import React, { Component } from 'react';
import { useHistory } from 'react-router-dom';
import {
  Navbar as BootstrapNavbar,
  NavDropdown,
  Dropdown,
  Nav,
  Container,
} from 'react-bootstrap';
import CustomToggle from '../../data-page/modules/CustomToggle';

const Navbar = () => {
  const history = useHistory();

  return (
    <div>
      <BootstrapNavbar bg='primary' variant='dark' expand='lg' fixed='top'>
        <Container>
          <BootstrapNavbar.Brand
            className='text-white'
            onClick={ () => history.push('/portal') }>
            Smarthealth
          </BootstrapNavbar.Brand>
          <BootstrapNavbar.Toggle aria-controls='basic-navbar-nav' />
          <BootstrapNavbar.Collapse id='basic-navbar-nav'>
            <Nav className='mr-auto'>
              <NavDropdown title='Pendaftaran Pasien' id='basic-nav-dropdown'>
                <NavDropdown.Item
                  onClick={ () => {
                    history.push('/service/puskesmas');
                  } }>
                  Puskesmas
                </NavDropdown.Item>
                <NavDropdown.Item disabled={ true }>Rumah Sakit</NavDropdown.Item>
              </NavDropdown>
              <NavDropdown
                title='Perizinan dan Sertifikasi'
                id='basic-nav-dropdown'>
                <NavDropdown.Item disabled={ true }>
                  Tenaga Kesehatan
                </NavDropdown.Item>
                <NavDropdown.Item disabled={ true }>
                  Sarana Kesehatan
                </NavDropdown.Item>
                <Dropdown drop='right'>
                  <Dropdown.Toggle as={ CustomToggle } id='dropdown-basic'>
                    Makanan dan Minuman
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item onClick={ () => {
                      history.push('/service/pirt');
                    } }>PIRT</Dropdown.Item>
                    <Dropdown.Item disabled={ true }>
                      Depot Air Minum
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={ () => {
                        history.push('/service/jasaboga');
                      } }
                      // disabled={ true }
                      >
                      Jasaboga
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={ () => {
                        history.push('/service/rumahmakan');
                      } }
                      // disabled={ true }
                      >
                      Rumah Makan
                    </Dropdown.Item>
                    <Dropdown.Item disabled={ true }>
                      Pedagang Kaki Lima
                    </Dropdown.Item>
                    {/* <Dropdown.Item disabled={ true }>Restoran</Dropdown.Item> */}
                    <Dropdown.Item disabled={ true }>Kantin</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
                <NavDropdown.Item
                  onClick={ () => {
                    history.push('/service/hotel');
                  } }
                  // disabled={ true }
                  >
                  Hotel
                </NavDropdown.Item>
              </NavDropdown>
            </Nav>
          </BootstrapNavbar.Collapse>
        </Container>
      </BootstrapNavbar>
    </div>
  );
};

export default Navbar;
